export enum TaskSource {
  ATHENA_INGESTION = "athena-ingest",
  CONCORD_INGESTION = "concord-ingest",
  ECW_CARELINK_INGESTION = "ecw-carelink-ingest",
  EMAIL_INGESTION = "email-ingest",
  FAX_INGESTION = "fax-ingest",
  FAX_OUTBOUND = "fax-outbound",
  SFTP_INGESTION = "sftp-ingest",
  WESTFAX_INGESTION = "westfax-ingest",
  SCRIPT_INGESTION = "script-ingest",
  UPLOAD_DOCUMENT = "upload-document-ingest",
  ENSO_INGESTION = "enso-ingest",
  NOTIFYMD_INGESTION = "notifymd-ingest",
  SPREADSHEET_INGESTION = "spreadsheet-ingest",
  VOICE_INGESTION = "voice-ingest",
}
